import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { kitemarkIcon, kitemarkFrame } from 'images';

const PREFIX = 'Kitemark';

const classes = {
  root: `${PREFIX}-root`,
  icon: `${PREFIX}-icon`,
  frame: `${PREFIX}-frame`,
  content: `${PREFIX}-content`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`&.${classes.root}`]: {
    position: 'relative',
    padding: theme.spacing(4),
    height: 300,
    width: 300,
    backgroundColor: 'transparent',
    borderRadius: 150
  },

  [`& .${classes.icon}`]: {
    position: 'absolute',
    width: '100%',
    marginLeft: -30,
    top: -10,
  },

  [`& .${classes.frame}`]: {
    left: 0,
    top: 0,
    width: '100%',
    position: 'absolute',
    zIndex: -1,
    '& > img': {
      margin: -20
    }
    // boxShadow: theme.shadows[5],
  },

  [`& .${classes.content}`]: {
    marginLeft: 5,
    marginTop: 100,
  }
}));

interface Props {
  helpText: string;
  title: string;
  subTitle: string;

}

export default function Kitemark(props: Props): JSX.Element {

  const { helpText, title, subTitle } = props;

  return (
    <Root className={classes.root}>
      <div className={classes.frame}>
        <img src={kitemarkFrame} />
      </div>
      <div className={classes.icon}>
        <img src={kitemarkIcon} />
      </div>
      <div className={classes.content}>
        <Typography variant="body1" color="inherit" align="center">
          <span>{helpText}</span>
        </Typography>
        <Typography variant="h4" color="primary" align="center">
          <span>{title}</span>
        </Typography>
        <Typography variant="h5" color="primary" align="center">
          <span>{subTitle}</span>
        </Typography>
      </div>
    </Root>
  );
}
